var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#443f38;}.cls-2{fill:#fff;}"));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M32.92,65.88A32.92,32.92,0,1,0,0,33,33,33,0,0,0,32.92,65.88",
  transform: "translate(0 -0.04)"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M31.67,2.87l1.27-1.28,1.27,1.28L32.94,4.14Zm0,0",
  transform: "translate(0 -0.04)"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M31.65,63.18l1.27-1.28,1.28,1.28-1.28,1.27Zm0,0",
  transform: "translate(0 -0.04)"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M61.81,33l1.27-1.27L64.36,33,63.08,34.3Zm0,0",
  transform: "translate(0 -0.04)"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M1.5,33l1.28-1.27L4.05,33,2.78,34.3Zm0,0",
  transform: "translate(0 -0.04)"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M31.58,29.51l2.25,5.7-5.55-2.55-16.2-20.4Zm0,0",
  transform: "translate(0 -0.04)"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M38.47,33.79l-4.64,1.42,1.72-4.5L51.38,18.63Zm0,0",
  transform: "translate(0 -0.04)"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M32.26,36.19l.07-2.85,2.86.08-.08,2.85Zm0,0",
  transform: "translate(0 -0.04)"
});
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "clock",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.85 65.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.dce0eb3e3c41397e60cd5c58e13c314c.svg";
export { ForwardRef as ReactComponent };